import { Directive, DirectiveBinding } from "vue";
import { routePermission } from "@/permission";
import { useUserStore } from "@/store";

type PermissionValue = string | string[];

function hasPermission(requiredPerms: PermissionValue) {
  if (typeof requiredPerms === "string") {
    return routePermission.has(requiredPerms);
  }
  return routePermission.hasAny(requiredPerms);
}

/**
 * 按钮权限
 */
export const hasPerm: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    // DOM绑定需要的按钮权限标识
    const { value: requiredPerms } =
      binding as DirectiveBinding<PermissionValue>;
    if (requiredPerms) {
      if (!hasPermission(requiredPerms)) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error(
        "need permissionKey! Like v-hasPerm=\"'office:workbench'\""
      );
    }
  },
};

/**
 * 角色权限
 */
export const hasRole: Directive = {
  mounted(el: HTMLElement, binding: DirectiveBinding) {
    // DOM绑定需要的角色编码
    const { value: requiredRoles } = binding as DirectiveBinding<
      string | string[]
    >;
    if (requiredRoles) {
      const userRoles = useUserStore().user.roles;
      const hasRole =
        typeof requiredRoles === "string"
          ? userRoles.includes(requiredRoles)
          : requiredRoles.some((role) => userRoles.includes(role));
      if (!hasRole) {
        el.parentNode && el.parentNode.removeChild(el);
      }
    } else {
      throw new Error("need roles! Like v-has-role=\"['admin','test']\"");
    }
  },
};
